import {ROUTES} from './routesConstants';

/**
 * Ordered list of route title mappings, from most specific to least specific.
 * Each entry maps a path prefix to a document title segment.
 * The first match wins — put more specific paths before their parent prefixes.
 *
 * Used by MainRoutes to call setDocumentTitle on every navigation.
 * Individual page components can call setDocumentTitle themselves for
 * deeper, context-specific titles (e.g. a campaign name).
 */
const ROUTE_TITLES: {prefix: string; title: string}[] = [
  // Preferences / account
  {prefix: ROUTES.PREFERENCES_TERMS_OF_SERVICE, title: 'Terms of Service'},
  {prefix: ROUTES.PREFERENCES, title: 'Account'},

  // Organization settings
  {
    prefix: ROUTES.ORGANIZATION_SETTINGS_BRANDS,
    title: 'Organization Settings > Brands',
  },
  {
    prefix: ROUTES.ORGANIZATION_SETTINGS_USERS,
    title: 'Organization Settings > Users',
  },
  {
    prefix: ROUTES.ORGANIZATION_SETTINGS_PLAN_BILLING,
    title: 'Organization Settings > Plan & Billing',
  },
  {
    prefix: ROUTES.ORGANIZATION_SETTINGS_PURCHASE_HISTORY,
    title: 'Organization Settings > Purchase History',
  },
  {prefix: ROUTES.ORGANIZATION_SETTINGS, title: 'Organization Settings'},

  // Campaigns
  {prefix: ROUTES.CAMPAIGNS_V2, title: 'Campaigns'},
  {prefix: ROUTES.CAMPAIGNS, title: 'Campaigns'},
  {prefix: ROUTES.NEW_CAMPAIGNS, title: 'Campaigns'},

  // Creators
  {prefix: ROUTES.CREATOR_CRM, title: 'Creators'},
  {prefix: ROUTES.RECRUIT_CRM, title: 'CRM Recruit Tracking'},
  {prefix: ROUTES.MY_CREATORS, title: 'Lists'},
  {prefix: ROUTES.CREATOR_PROFILE, title: 'Creator Profile'},
  {prefix: ROUTES.SEARCH, title: 'Search'},

  // Content
  {prefix: ROUTES.CONTENT_LIBRARY, title: 'Content Library'},
  {prefix: ROUTES.CONTENT__LIBRARY, title: 'Content Library'},
  {prefix: ROUTES.CONTENT_LAB, title: 'Content Studio'},

  // Partnerships & vetting
  {prefix: ROUTES.PARTNERSHIPS, title: 'Partnerships'},
  {prefix: ROUTES.VETTING, title: 'Safe Collab'},

  // Other
  {prefix: ROUTES.PRICING, title: 'Pricing'},
  {prefix: ROUTES.STATS, title: 'Stats'},
  {prefix: ROUTES.THREADS, title: 'Threads'},
  {prefix: ROUTES.HOME, title: ''},
];

export default ROUTE_TITLES;
